import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddTimeLineDialogComponent } from './add-dialog-time-lines.component';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { LocalizedNativeDateModule } from 'src/app/core/i18n/localized-date-adapter';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatDialogModule,
    FlexLayoutModule,
    MatStepperModule,
    MatRadioModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatRippleModule,
    LocalizedNativeDateModule,
    MatSlideToggleModule,
    TranslocoModule
  ],
  declarations: [
    AddTimeLineDialogComponent
  ],
  exports: [AddTimeLineDialogComponent]
})
export class AddTimeLineDialogModule { }
